angular.module('impactx.suppliercatalogupload').service('CatalogImportService', CatalogImportService);

CatalogImportService.$inject = ['$mdDialog', 'dataGen'];

function CatalogImportService($mdDialog, dataGen) {
    return {
        showCatalogImportDialogPreSetData: function (callBackFunction, event, data, trns, hideImportDateType) {
            $mdDialog.show({
                controller: "CatalogSupplierImportCtrl",
                controllerAs: "catalogSupplierImportCtrl",
                templateUrl: "modules/suppliercatalogupload/templates/catalogimportdialog.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    data: data,
                    trns: trns,
                    hideImportDateType: hideImportDateType
                }
            })
                .then(function (dialogData) {
                    var dataObj = {
                        settings: dialogData
                    };
                    var tempScope = {};
                    dataGen.postAsForm(tempScope, dataObj, "/catalog/supplieruploadimport").then(function () {
                        callBackFunction(tempScope.trns.statusMessage);
                    });

                }, function () {
                });
        },
        showCatalogImportDialogNewData: function (callBackFunction, event, catTrackId) {
            var tempScope = {};
            dataGen.getData(tempScope, {catTrackId: catTrackId}, "/catalog/importdatafromcattrack").then(function () {
                    $mdDialog.show({
                        controller: "CatalogSupplierImportCtrl",
                        controllerAs: "catalogSupplierImportCtrl",
                        templateUrl: "modules/suppliercatalogupload/templates/catalogimportdialog.tmpl.html",
                        parent: angular.element(document.body),
                        targetEvent: event,
                        clickOutsideToClose: false,
                        locals: {
                            data: tempScope.data,
                            trns: tempScope.trns
                        }
                    })
                        .then(function (dialogData) {
                            var dataObj = {
                                settings: dialogData
                            };
                            var tempScope = {};
                            dataGen.postAsForm(tempScope, dataObj, "/catalog/supplieruploadimport").then(function () {
                                callBackFunction(tempScope.trns.statusMessage);
                            });

                        }, function () {

                        });
                }
            )
        }
    }
}